<div class="bg-white">
    <div class="bg-white px-4 pt-4 shadow-md">
        <div class="relative flex flex-row justify-center">
            <ion-icon
                class="absolute left-0 mr-1 text-xl dark:filter-yellow"
                (click)="handleBackClicked()"
                src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg"></ion-icon>
            <h1 class="mb-4 text-center text-base font-semibold leading-5">
                {{ 'TICKET_QR' | translate }}
            </h1>
        </div>
    </div>

    <div class="loader-container flex items-center justify-center" *ngIf="hideQrCode">
        <ridango-ui-basic-loading-spinner [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
        </ridango-ui-basic-loading-spinner>
    </div>

    <div class="qr-wrapper overflow-auto">
        <div
            class="flex-align-center qr-container flex justify-center p-2"
            #qrContainer
            [class.qr-container-ios]="isIosPlatform">
            <rwidget-ticket-qr
                class="transition-opacity"
                *ngIf="ticket"
                [class.opacity-0]="hideQrCode"
                [ticket]="ticket"
                [isPage]="true"></rwidget-ticket-qr>
        </div>
    </div>
</div>
